import { faEllipsisVertical } from '@fortawesome/pro-regular-svg-icons';
import Flex from 'components/ui/Flex';
import IconButton from 'components/ui/IconButton';
import ItemsList, { ItemListAction, ItemsListWrapper } from 'components/ui/ItemsList';
import { ThemeColors } from 'styled-components';
import { useState } from 'react';
import { styled } from 'styled-components';

type RowActionsMenuProps = {
    actions: ItemListAction[];
    className?: string;
    iconBgColor?: keyof ThemeColors;
    disabled?: boolean;
};

const RowActionsMenu = ({ actions, className, iconBgColor = 'white', disabled }: RowActionsMenuProps) => {
    const [showActionsMenu, setShowActionsMenu] = useState(false);

    if (!actions.length) return null;

    return (
        <Wrapper align="center" className="position-relative">
            <IconButton
                icon={faEllipsisVertical}
                bgColor={iconBgColor}
                disableFont
                disabled={disabled}
                onClick={(e) => {
                    e.stopPropagation();
                    e.preventDefault();
                    setShowActionsMenu(true);
                }}
                className="cursor-pointer"
            />
            {showActionsMenu && (
                <ItemsListWrapper>
                    <ItemsList<ItemListAction>
                        className={className}
                        absolutePositioned={null}
                        onClickOutside={() => setShowActionsMenu(false)}
                        onItemPress={(_e, item) => {
                            item.onClick();
                            setShowActionsMenu(false);
                        }}
                        items={actions}
                        childrenTitleKey="label"
                        childrenIconKey="icon"
                        breakParentWidth
                    />
                </ItemsListWrapper>
            )}
        </Wrapper>
    );
};

export default RowActionsMenu;

const Wrapper = styled(Flex)`
    position: relative;
`;
